module.exports = __webpack_public_path__ + "static/stories-ccce84da268a6fd91650d20e09345f71.jpg";